<app-header></app-header>
<div class="pg-wrp">
    <div class="container">



        <div class="row">

            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mid-screen-pnt">
                <h3 class="pay-sec">Manage Users</h3>
                <!-- <div class="lod-sec ds-bk">
          <a class="cursor-pointer">
            <div class="ds-bk-label">
              <div class="ds-bk-label-ins">
                <label>Name</label>
              </div>
              <div class="ds-bk-label-ins">
                <label>PhoneNumber</label>
              </div>
              <div class="ds-bk-label-ins">
                <label>Email</label>
              </div>
              <div class="ds-bk-label-ins">
                <label>Registered Date</label>
              </div>
              <div class="ds-bk-label-ins">
                <label>Current Access Level</label>
              </div>
              <div class="ds-bk-label-ins">
                <label>Update Access Level</label>
              </div>
            </div>
            <div class="ds-bk-sec" *ngFor="let list of userList['userlist']">
              <div class="ds-txt ds-co">
                <p>{{list.name}}</p>
              </div>


              <div class="ds-txt2 ds-co">
                <p>{{list.mobile}}</p>
              </div>
              <div class="ds-txt2 ds-co">
                <p title={{list.emailID}}>{{list.emailID}}</p>
              </div>
              <div class="ds-txt2 ds-co">
                <p>{{list.createdDate | date:'dd/MM/yyyy'}}</p>
              </div>

              <div class="ds-txt2 ds-co">
                <p>{{list.groupName}}</p>
              </div>

              <div class="ds-txt2 ds-co">
                <select (change)="setRights(list,$event)">
                  <option selected value="" disabled>Select Access Level</option>
                  <option *ngFor="let opt of  userList['grouplist']" [value]="opt.id">{{opt.groupName}}</option>
                </select>
              </div>


              <div class="lod-sec ds-bk">
                  <div class="ds-bk-sec">
                        <div class="ds-txt ds-co">
                            <label>Invoice Number</label>
                            <p>QUO0124686</p>
                        </div>
  
                        <div class="ds-txt2 ds-co">
                            <label>Order Value</label>
                            <p>₹ 2000</p>
                        </div>
                        <div class="ds-txt3 ds-co">
                          <label>Valid till</label>
                          <p>09 Jan 2021</p>
                        </div>
                  </div>
                      <div class="ad-fix-sec">
                          <div class="ds-tol">
                            <label>Status</label>
                            <button class="edit-btn"><a>Editable</a></button>
                          </div>
                        <div class="ad-cd-sc">
                          <p>Add to Cart<img src="../../../assets/images/ad-arrow.png" alt=""></p>
                        </div>
                    </div>
                </div>
  
                <div class="lod-sec ds-bk">
                  <div class="ds-bk-sec">
                        <div class="ds-txt ds-co">
                            <label>Invoice Number</label>
                            <p>QUO0124686</p>
                        </div>
  
                        <div class="ds-txt2 ds-co">
                            <label>Order Value</label>
                            <p>₹ 2000</p>
                        </div>
                        <div class="ds-txt3 ds-co">
                          <label>Valid till</label>
                          <p>09 Jan 2021</p>
                        </div>
                  </div>
                      <div class="ad-fix-sec">
                          <div class="ds-tol">
                            <label>Status</label>
                            <button class="edit-btn"><a>Editable</a></button>
                          </div>
                        <div class="ad-cd-sc">
                          <p>Add to Cart<img src="../../../assets/images/ad-arrow.png" alt=""></p>
                        </div>
                    </div>
                </div>
  
                <div class="lod-sec ds-bk">
                  <div class="ds-bk-sec">
                        <div class="ds-txt ds-co">
                            <label>Invoice Number</label>
                            <p>QUO0124686</p>
                        </div>
  
                        <div class="ds-txt2 ds-co">
                            <label>Order Value</label>
                            <p>₹ 2000</p>
                        </div>
                        <div class="ds-txt3 ds-co">
                          <label>Valid till</label>
                          <p>09 Jan 2021</p>
                        </div>
                  </div>
                      <div class="ad-fix-sec">
                          <div class="ds-tol">
                            <label>Status</label>
                            <button class="edit-btn"><a>Editable</a></button>
                          </div>
                        <div class="ad-cd-sc">
                          <p>Add to Cart<img src="../../../assets/images/ad-arrow.png" alt=""></p>
                        </div>
                    </div>
                </div>
  
                <div class="lod-sec ds-bk">
                  <div class="ds-bk-sec">
                        <div class="ds-txt ds-co">
                            <label>Invoice Number</label>
                            <p>QUO0124686</p>
                        </div>
  
                        <div class="ds-txt2 ds-co">
                            <label>Order Value</label>
                            <p>₹ 2000</p>
                        </div>
                        <div class="ds-txt3 ds-co">
                          <label>Valid till</label>
                          <p>09 Jan 2021</p>
                        </div>
                  </div>
                      <div class="ad-fix-sec">
                          <div class="ds-tol">
                            <label>Status</label>
                            <button class="edit-btn"><a>Editable</a></button>
                          </div>
                        <div class="ad-cd-sc">
                          <p>Add to Cart<img src="../../../assets/images/ad-arrow.png" alt=""></p>
                        </div>
                    </div>
                </div>

            </div>
          </a>
        </div> -->

                <!-- newly added table-21/12/21 -->
                <div class="table-responsive">
                    <table>
                        <thead class="ds-bk-label">
                            <tr>
                                <th class="ds-bk-label-ins">Name</th>
                                <th class="ds-bk-label-ins">PhoneNumber</th>
                                <th class="ds-bk-label-ins">Email</th>
                                <th class="ds-bk-label-ins">Registered date</th>
                                <th class="ds-bk-label-ins">Current Access Level</th>
                                <th class="ds-bk-label-ins">Update Access Level</th>
                            </tr>
                        </thead>
                        <tbody class="ds-bk-sec" *ngFor="let list of userList['userlist']">
                            <tr style="line-height: 2.4;">
                                <td>
                                    <div class="ds-txt ds-co">
                                        <p class="mb-0">{{list.name}}</p>
                                    </div>
                                </td>
                                <td>
                                    <div class="ds-txt2 ds-co">
                                        <p class="mb-0">{{list.mobile}}</p>
                                    </div>
                                </td>
                                <td>
                                    <div class="ds-txt2 ds-co">
                                        <p title={{list.emailID}} class="mb-0">{{list.emailID}}</p>
                                    </div>
                                </td>
                                <td>
                                    <div class="ds-txt2 ds-co">
                                        <p class="mb-0">{{list.createdDate | date:'dd/MM/yyyy'}}</p>
                                    </div>
                                </td>
                                <td>

                                    <div class="ds-txt2 ds-co">
                                        <p class="mb-0">{{list.groupName}}</p>
                                    </div>
                                </td>
                                <td>
                                    <div class="ds-txt2 ds-co">
                                        <select (change)="setRights(list,$event)">
                      <option selected value="" disabled>Select Access Level</option>
                      <option *ngFor="let opt of  userList['grouplist']" [value]="opt.id">{{opt.groupName}}</option>
                    </select>
                                    </div>
                                </td>
                            </tr>

                        </tbody>
                    </table>
                </div>

                <div class="btn-sec mid-btn">
                    <!-- <button ><a>Need Assistance</a></button> -->
                </div>
            </div>
        </div>
        <app-footer></app-footer>